// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"353":"contact","594":"about","597":"projects","671":"services","752":"project-detail"}[chunkId] + "." + {"353":"36722418","594":"32565cab","597":"8dc34ab5","671":"a03c38b2","752":"cbfef746"}[chunkId] + ".js";
};